module.exports = __webpack_public_path__ + "img/45.464e4dd1.jpg";